/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UsageFeeBillsInner
 */
export interface UsageFeeBillsInner {
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'billId': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'bankAccountActivityId': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'latestStatus': UsageFeeBillsInnerLatestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof UsageFeeBillsInner
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'appliedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFeeBillsInner
     */
    'transferDate': string;
}

export const UsageFeeBillsInnerLatestStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type UsageFeeBillsInnerLatestStatusEnum = typeof UsageFeeBillsInnerLatestStatusEnum[keyof typeof UsageFeeBillsInnerLatestStatusEnum];


